"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConnectionsButton = exports.EntityConnectionsButtonDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_icons_1 = require("../../hooks/use-icons");
var icon_button_1 = require("../elements/icon-button");
exports.EntityConnectionsButtonDefaultProps = {
  useSpan: true,
  iconSize: 18
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props._isActive && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var EntityConnectionsButton = function (props) {
  var className = props.className,
    entity = props.entity,
    entityTypeName = props.entityTypeName,
    useSpan = props.useSpan,
    iconSize = props.iconSize,
    isActive = props.isActive;
  var definition = entityTypeName ? (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName) : (0, use_entity_definition_1.useEntityDefinition)(entity);
  if (!definition) {
    throw new Error("Error: Entity Connections Buton cannot be rendered. Cannot determine type name");
  }
  var icons = (0, use_icons_1.useIcons)();
  var Icon = icons.AppSections.Platform;
  var t = (0, use_lang_1.useLang)();
  var label = t('Connections');
  var route = isActive ? definition.to(entity.slug) : definition.to(entity.slug, 'connections');
  return React.createElement(My.Container, {
    icon: React.createElement(Icon, null),
    iconSize: iconSize,
    isActive: isActive,
    className: className,
    useSpan: useSpan,
    priority: "icon",
    onClick: route && function () {
      return (0, router_1.navigate)(route);
    }
  }, label);
};
exports.EntityConnectionsButton = EntityConnectionsButton;
exports.EntityConnectionsButton.defaultProps = exports.EntityConnectionsButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;